let baseURL = "https://odesk.geezdata.com";
let wsURL = "wss://odesk.geezdata.com";

export { baseURL, wsURL };
